import React, { useContext, useEffect, useState } from "react";
import { DiscadorContext } from "../../../Discador";
import { useModal } from "../../../../hooks/ModalContext";
import { useClear } from "../../../../hooks/useClear";
import { IoIosWarning } from "react-icons/io";
// import { PiHeadsetBold } from "react-icons/pi";
import iconLogin from '../../../../assets/icons/login_discador.svg'

interface DiscadorSelectsProps {
  automatico?: boolean
}


export const DiscadorSelects = ({ automatico }: DiscadorSelectsProps) => {
  const { dadosChamada, qualificarChamada, dadosCampanha, logarSessao } = useContext(DiscadorContext)
  const [qualificacao, setQualificacao] = useState('')
  const [campanha, setCampanha] = useState('')
  const [headset, setHeadset] = useState(false)
  const { modalInfo, onClose } = useModal()
  const { clearData } = useClear()

  async function qualificar() {
    await qualificarChamada(qualificacao, String(dadosChamada?.call?.id))
    clearData()
    onClose()
  }

  async function escolherCampanha() {
    await logarSessao(campanha)
    onClose()
  }

  useEffect(() => {
    setHeadset(false)
  }, [modalInfo])

  useEffect(() => {
    console.log(dadosCampanha)
    if (dadosCampanha && dadosCampanha?.length > 0) {
      setCampanha(String(dadosCampanha[0]?.id))
    }
  }, [])


  return (
    <div className="">
      {
        modalInfo.title === 'Qualificacao Chamada' && (
          <div className="flex-col items-center">
            <strong className="text-primary font-normal text-lg">Qualificações: </strong>
            <select
              className="w-full rounded-sm bg-gray-200 p-4 mt-2 text-xs text-gray-600 outline-none"
              value={qualificacao}
              onChange={(e) => setQualificacao(e.target.value)}

            >
              {
                dadosChamada && dadosChamada?.qualification?.qualifications && dadosChamada?.qualification?.qualifications?.length > 0 && dadosChamada?.qualification?.qualifications.map(quali => (
                  <option key={quali.id} value={quali.id}>{quali.name}</option>
                ))
              }
            </select>
          </div>
        )
      }

      {
        modalInfo.title === 'Campanha Discador' && (
          <>
            {
              (automatico && headset) || !automatico ? (
                <div className="flex flex-col items-center w-full justify-center">
                  {/* <strong className="text-primary font-normal text-lg">Campanhas: </strong>
                  <select
                    className="w-full rounded-sm bg-gray-200 p-4 mt-2 text-xs text-gray-600 outline-none"
                    value={campanha}
                    onChange={(e) => setCampanha(e.target.value)}

                  >
                    {
                      dadosCampanha && dadosCampanha?.length > 0 && <>
                        <option key="" value="" className="text-base"></option>
                        {
                          dadosCampanha?.map(camp => (
                            <option key={camp.id} value={camp.id} className="text-base">{camp.name}</option>
                          ))
                        }

                      </>
                    }
                  </select> */}
                  <div className=" -mb-6 -mt-10 ml-4">
                    {/* <PiHeadsetBold size={70} className="fill-primary" /> */}
                    <img src={iconLogin} alt="" className="w-[100%]" />
                  </div>

                  <p className="text-gray-800 text-lg w-full text-center">Por favor, acesse o seguinte link: <strong className="font-normal text-blue-600 hover:underline" onClick={() => { window.open("https://gazin.3c.plus/login", "_blank"); }}>Login Discador</strong>, faça login com seu usuário e senha, e selecione a campanha desejada.</p>
                </div>
              ) : (
                <div className="flex flex-col items-center -mx-4">
                  <IoIosWarning className="fill-amber-500 " size={70} />
                  <p className=" font-medium w-[60%] text-center">Certifique-se que você conectou o fone e o microfone antes de logar.</p>
                  <button className="p-2 text-white bg-green-500 rounded-md w-[70%] mt-4 -mb-4" onClick={() => setHeadset(true)}>Está tudo OK!</button>
                </div>
              )
            }
          </>
        )
      }

      {
        modalInfo.title !== 'Campanha Discador' && <button className={`-mb-4 mt-4 w-full rounded-md bg-primary p-1 font-semibold text-white ${automatico && !headset && 'hidden'}`} onClick={() => modalInfo.title === 'Campanha Discador' ? escolherCampanha() : qualificar()}>{modalInfo.title === 'Campanha Discador' ? 'Iniciar Sessão' : 'Qualificar'}</button>
      }
      {/* bg-error */}
      {/* <button className={`-mb-4 mt-4 w-full rounded-md bg-primary p-1 font-semibold text-white ${automatico && !headset && 'hidden'}`} onClick={() => modalInfo.title === 'Campanha Discador' ? escolherCampanha() : qualificar()}>{modalInfo.title === 'Campanha Discador' ? 'Iniciar Sessão' : 'Qualificar'}</button> */}
    </div >
  )
}